import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";
import { putData } from "../../../utils/api";
import { CouponType, formatDate, Select2Data } from "../../../utils/common";
import Loader from "../../common/Loader";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
    watch,
    clearErrors,
  } = useForm();

  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  const GetEditData = async () => {
    try {
      setLoading(true);

      const response = await getData(`/admin/products/offered-product/${id}`);
      const formattedStartDate = response?.data?.start_date
        ? formatDate(response?.data?.start_date)
        : "";
      const formattedEndDate = response?.data?.end_date
        ? formatDate(response?.data?.end_date)
        : "";
      reset({
        ...response?.data,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      });

      if (response?.data?.coupon_type_id?.value === CouponType.Percentage) {
        setValue("discount_per", response?.data?.discount);
      }
      console.log({ response: response });

      if (response?.data?.product_id?.value) {
        getProductVariant(response?.data?.product_id?.value);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const imageFile = watch("image");
  const [products, setProducts] = useState([]);

  const onSubmit = async (data) => {
    try {
      setSubmitLoading(true);

      const finalData = new FormData();
      finalData.append("product_id", data?.product_id?.value);
      finalData.append("discount_type_id", data?.discount_type_id?.value);
      finalData.append("message", data?.message);
      finalData.append("discount", data?.discount);

      finalData.append("start_date", data?.start_date);
      finalData.append("end_date", data?.end_date);
      // finalData.append(
      //   "discount",
      //   data?.discount_type_id?.value === CouponType.Percentage
      //     ? data?.discount_per
      //     : data?.discount
      // );
      if (data.image) {
        finalData.append("image", data.image[0]);
      }
      const response = await putData(
        `/admin/products/offered-product/${id}`,
        finalData,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitLoading(false);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const dropdownList = [
    {
      value: CouponType.Percentage,
      name: "discount_type_id",
      label: "Percentage",
    },
    {
      value: CouponType.FixedAmount,
      name: "discount_type_id",
      label: "Fixed Amount",
    },
  ];

  const getAllProducts = async () => {
    const response = await getData(`/common/masters/product`);
    if (response?.success) {
      setProducts(await Select2Data(response?.data, "product_id"));
    }
  };

  const [today, setToday] = useState("");

  useEffect(() => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0]; // YYYY-MM-DD format
    setToday(formattedDate);
    getAllProducts();
  }, []);

  const [product, setProduct] = useState(null);
  const getProductVariant = async (id) => {
    const response = await getData(`/common/masters/product-varient-low/${id}`);
    if (response?.success) {
      setProduct(response?.data);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Offered Products
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <Loader />
          ) : (
            <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
              <Row className="">
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Product</Form.Label>
                      </div>
                      <InputGroup>
                        <Controller
                          name="product_id" // name of the field
                          {...register("product_id", {
                            required: "Select Product",
                          })}
                          control={control}
                          render={({ field }) => (
                            <Select
                              defaultValue={dropdownList[0]}
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderColor: errors.product_id
                                    ? "red"
                                    : baseStyles,
                                }),
                              }}
                              {...field}
                              options={products}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                getProductVariant(selectedOption?.value);
                              }}
                            />
                          )}
                        />
                      </InputGroup>
                      {errors.product_id && (
                        <span className="text-danger">
                          {errors.product_id.message}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Type</Form.Label>
                      </div>
                      <InputGroup>
                        <Controller
                          name="discount_type_id" // name of the field
                          {...register("discount_type_id", {
                            required: "Select discount_type_id",
                          })}
                          control={control}
                          render={({ field }) => (
                            <Select
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderColor: errors.discount_type_id
                                    ? "red"
                                    : baseStyles,
                                }),
                              }}
                              {...field}
                              options={dropdownList}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                clearErrors("discount");
                              }}
                            />
                          )}
                        />
                      </InputGroup>
                      {errors.discount_type_id && (
                        <span className="text-danger">
                          {errors.discount_type_id.message}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                </Col>

                {watch("discount_type_id")?.value === CouponType.Percentage ? (
                  <Col md={6}>
                    <div className="main-form-section mt-3">
                      <Form.Group>
                        <div className="">
                          <Form.Label>Discount (%)</Form.Label>
                        </div>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            name="discount"
                            placeholder="Discount"
                            className={classNames("", {
                              "is-invalid": errors?.discount,
                            })}
                            {...register("discount", {
                              required: "Discount is required", // Percentage validation
                              pattern: {
                                value: /^[0-9]{1,2}(\.[0-9]{1,2})?$/, // Allows up to two decimal places
                                message:
                                  "Please enter a valid discount (up to two decimal places)",
                              },
                              validate: (value) => {
                                return (
                                  parseFloat(value) <= 99.99 ||
                                  "Discount cannot exceed 99.99"
                                ); // Max limit for Percentage
                              },
                            })}
                            onKeyDown={(e) => {
                              const currentValue = e.target.value;
                              // Allow left and right arrows and backspace
                              if (
                                e.key === "ArrowLeft" ||
                                e.key === "ArrowRight" ||
                                e.key === "Backspace"
                              ) {
                                return;
                              }
                              // Ensure only numbers and a single decimal point are allowed
                              if (
                                !/[\d\.]/.test(e.key) ||
                                (e.key === "." && currentValue.includes(".")) ||
                                (currentValue.length >= 5 &&
                                  e.key !== "Backspace") ||
                                (currentValue.includes(".") &&
                                  currentValue.split(".")[1].length >= 2 &&
                                  e.key !== "Backspace")
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </InputGroup>
                        {errors.discount && (
                          <span className="text-danger">
                            {errors.discount.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                ) : (
                  <Col md={6}>
                    <div className="main-form-section mt-3">
                      <Form.Group>
                        <div className="">
                          <Form.Label>Discount</Form.Label>
                        </div>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            name="discount"
                            placeholder="Discount"
                            className={classNames("", {
                              "is-invalid": errors?.discount,
                            })}
                            {...register("discount", {
                              required: "Discount is required", // Fixed Amount validation
                              validate: (value) => {
                                const variantPrice = Number(
                                  product?.price || 0,
                                );

                                if (Number(value) <= 0) {
                                  return "Discount must be greater than 0";
                                }

                                if (Number(value) > variantPrice) {
                                  return `Discount cannot be greater than Variant Price (${variantPrice})`;
                                }

                                return true;
                              },
                            })}
                            onKeyDown={(e) => {
                              const currentValue = e.target.value;
                              // Allow left and right arrows and backspace
                              if (
                                e.key === "ArrowLeft" ||
                                e.key === "ArrowRight" ||
                                e.key === "Backspace"
                              ) {
                                return;
                              }
                              // Prevent non-numeric values
                              if (!/[\d]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </InputGroup>
                        {errors.discount && (
                          <span className="text-danger">
                            {errors.discount.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                )}

                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Start Date</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          name="start_date"
                          placeholder="Start Date"
                          // min="0001-01-01"
                          max="9999-12-31"
                          className={classNames("", {
                            "is-invalid": errors?.start_date,
                          })}
                          min={today}
                          {...register("start_date", {
                            required: "Start Date is required",
                            validate: (value) => {
                              const startDate = new Date(value);
                              const todayDate = new Date(today);
                              return (
                                todayDate <= startDate ||
                                "Start date must be today or in the future"
                              );
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.start_date && (
                        <span className="text-danger">
                          {errors.start_date.message}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <div className="">
                        <Form.Label>End Date</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          name="end_date"
                          // min="0001-01-01"
                          max="9999-12-31"
                          placeholder="End Date"
                          className={classNames("", {
                            "is-invalid": errors?.end_date,
                          })}
                          min={watch("start_date")}
                          {...register("end_date", {
                            required: "End Date is required",
                            validate: (value) => {
                              const startDate = new Date(watch("start_date"));
                              const endDate = new Date(value);

                              return (
                                endDate >= startDate ||
                                "End date must be greater than or equal to start date"
                              );
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.end_date && (
                        <span className="text-danger">
                          {errors.end_date.message}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Message</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          as={"textArea"}
                          name="message"
                          placeholder="Message"
                          className={classNames("", {
                            "is-invalid": errors?.message,
                          })}
                          {...register("message", {
                            required: "Message is required",
                          })}
                        />
                      </InputGroup>
                      {errors.message && (
                        <span className="text-danger">
                          {errors.message.message}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Image</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="file"
                          name="image"
                          placeholder="Image"
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          {...register("image", {
                            // required: "Image is required",
                          })}
                          accept="image/*"
                          // onChange={handleImageChange}
                        />
                      </InputGroup>
                      {errors.image && (
                        <span className="text-danger">
                          {errors.image.message}
                        </span>
                      )}
                    </Form.Group>
                    {imagePreview && (
                      <div className="mt-2">
                        <img
                          src={imagePreview}
                          alt="Category Preview"
                          style={{ maxWidth: "100px" }}
                        />
                      </div>
                    )}
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="main-form-section mt-3">
                    <Form.Label>Image Preview</Form.Label>

                    {typeof getValues("image") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    ) : (
                      imageFile &&
                      imageFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(imageFile[0])}
                            alt="Preview"
                            className="image-preview"
                          />
                        </div>
                      )
                    )}
                  </div>
                </Col>

                <Row className="mt-5 pb-3">
                  <div className="d-flex justify-content-center">
                    <Link>
                      <CancelButton
                        name={"cancel"}
                        handleClose={props.handleClose}
                      />
                    </Link>

                    <SaveButton
                      name={"save"}
                      loading={submitLoading}
                      handleSubmit={handleSubmit(onSubmit)}
                    />
                  </div>
                </Row>
              </Row>
            </Form>
          )}
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
